import { createStore } from 'satcheljs';
import AccountsEditorStore from './schema/AccountsEditorState';

const defaultAccountsEditorStore: AccountsEditorStore = {
    accountPendingTrueTimeUpdate: null,
    trueTimeUpdateFailedAccount: null,
    accountsEditorState: 0,
    selectedAccountProvider: null,
    source: null,
};

export const getStore = createStore<AccountsEditorStore>(
    'accountsEditorStore',
    defaultAccountsEditorStore
);
export default getStore;
